export default __webpack_public_path__ + "static/media/Group_644.f67c4170.svg";